import { formatISO, addMinutes, addHours, startOfDay, format, parseISO } from "date-fns";
const toTimeString = (time) => {
  if (!time)
    return "00:00";
  const hours = time.getHours().toString().padStart(2, "0");
  const minutes = time.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};
const timeStringToDate = (hour) => {
  if (!hour)
    return null;
  const [hours, minutes] = String(hour).split(":");
  if (hours === void 0 || minutes === void 0)
    return null;
  return formatISO(addMinutes(addHours(startOfDay(/* @__PURE__ */ new Date()), Number(hours)), Number(minutes)));
};
const SECOND = 1e3;
const MINUTE = 60 * SECOND;
const minutesToMs = (minutes) => minutes * MINUTE;
const toDate = (date) => new Date(date);
const addTimezoneOffset = (time) => `${time}${format(/* @__PURE__ */ new Date("2025-01-01"), "xxx")}`;
const convertUtcToLocalTimezone = (time) => format(parseISO(`2025-01-01T${time}`), "HH:mm:ssxxx");
export {
  addTimezoneOffset,
  convertUtcToLocalTimezone,
  minutesToMs,
  timeStringToDate,
  toDate,
  toTimeString
};
